export default {
  login: {
    title: 'Masuk',
    usernameLabel: 'Nama Pengguna',
    usernamePlaceholder: 'Masukkan 2-10 kombinasi digit nama Anda',
    loginPasswordLabel: 'kata sandi masuk',
    loginPasswordPlaceholder: 'Masukkan kata sandi Anda',
    googleCodeLabel: 'kode verifikasi Google',
    googleCodePlaceholder: 'Masukkan kode verifikasi Google 6 digit',
    hasNoAccount: 'Belum ada akun,',
    goRegister: 'Pergi untuk mendaftar',
    onlineCustom: 'Layanan pelanggan online',
    loginArgument: 'Melanjutkan login berarti setuju',
    userArgument: '《Perjanjian Pengguna》',
    registerNotEnabled: 'Fungsi pendaftaran tidak terbuka, harap hubungi administrator',
    usernameRequired: 'Masukkan nama pengguna yang benar',
    loginPasswordRequired: 'Masukkan kata sandi login yang benar',
    googleCodeRequired: 'Masukkan kode verifikasi Google yang benar',
    loginButton: 'Masuk'
  },
  register: {
    title: 'Daftar',
    usernameLabel: 'Nama Pengguna',
    usernamePlaceholder: 'Masukkan 2-10 kombinasi digit nama Anda',
    loginPasswordLabel: 'Kata sandi masuk',
    loginPasswordPlaceholder: 'Masukkan kata sandi Anda',
    loginPasswordPreLabel: 'Konfirmasi kata sandi masuk',
    loginPasswordPrePlaceholder: 'Masukkan ulang kata sandi Anda',
    fudPasswordLabel: 'Kata sandi dana',
    fudPasswordPlaceholder: 'Masukkan kata sandi dana',
    inviteCodeLabel: 'Kode Undangan',
    inviteCodePlaceholder: 'Masukkan kode undangan 6 digit',
    registerNeed: 'Lanjutkan daftar berarti setuju',
    registerArgument: '《Perjanjian Pendaftaran》',
    usernameRequired: 'Masukkan nama pengguna yang benar',
    loginPasswordRequired: 'Masukkan kata sandi login yang benar',
    loginPasswordPreRequired: 'Masukkan kata sandi login konfirmasi yang benar',
    fundPasswordRequired: 'Masukkan kata sandi dana yang benar',
    inviteCodeRequired: 'Masukkan kode undangan yang benar',
    diffLoginPasswordError: 'Kedua kata sandi masuk tidak konsisten',
    registerSuccess: 'Pendaftaran berhasil',
    registerButton: 'Daftar',
    emailLabel: 'Email',
    emailPlaceholder: 'Masukkan alamat email Anda',
    emailCodeLabel: 'Kode verifikasi',
    emailCodePlaceholder: 'Masukkan kode verifikasi email Anda',
    second: 'kedua',
    getEmailCodeButton: 'Dapatkan kode',
    emailRequired: 'Masukkan alamat email yang benar dan coba lagi',
    emailCodeRequired: 'Masukkan kode verifikasi email yang benar dan coba lagi'
  },
  home: {
    hotCoin: {
      title: 'Penawaran Panas',
      more: 'Lebih'
    },
    poster: {
      title: 'Setoran cepat',
      enter: 'Masuk sekarang>',
      subTitle: 'Mendukung BTC, USDT, ETH, dll.'
    },
    quickMenus: {
      futuresTrading: 'Perdagangan Berjangka',
      helpCenter: 'Pusat Bantuan'
    },
    ranking: {
      increase: {
        title: 'Daftar naik'
      },
      clinch: {
        title: 'Daftar Omzet'
      }
    }
  },
  tabBar: {
    home: 'Beranda',
    price: 'Market',
    trade: 'Trade',
    fund: 'Aset',
    user: 'Profil'
  },
  currency: {
    favorite: 'Opsional',
    allCurrency: 'titik',
    dayVol: 'jumlah 24 jam',
    addFavor: '+ Tambahkan Bantuan'
  },
  trade: {
    bills: 'Tagihan',
    todayOpen: 'Buka',
    star: 'Opsional',
    vol: 'Volume',
    low: 'terendah',
    high: 'tertinggi',
    timing: 'Kecepatan ekstrim',
    spot: 'Futures',
    buyMore: 'beli lebih banyak',
    buyEmpty: 'beli pendek',
    indicator: 'Indikator',
    indicatorSettings: 'Pengaturan Indikator',
    balance: 'saldo saya',
    fee: 'biaya layanan',
    ruleIdError: 'Silakan pilih waktu kedaluwarsa',
    deleteFavoriteSuccess: 'Berhasil menghapus mata uang favorit',
    addFavoriteSuccess: 'Menambahkan mata uang yang dipilih berhasil',
    buyIn: 'beli',
    sellOut: 'Jual',
    holding: 'memegang posisi',
    history: 'Sejarah',
    spotOrderConfirm: {
      title: 'Konfirmasi Beli',
      amountPlaceholder: 'Masukkan jumlah pembelian'
    },
    spotTradeOrder: {
      holding: {
        coin: 'mata uang',
        buyInAmountPrice: 'Harga total beli/harga satuan',
        buyInCount: 'Kuantitas',
        actions: 'operasi',
        sellOut: 'Jual',
        profit: 'untung dan rugi'
      }
    },
    orderConfirm: {
      title: 'Konfirmasi Pesanan',
      coinName: 'mata uang',
      direction: 'arah',
      price: 'harga saat ini',
      balance: 'Saldo({simbol})',
      fee: 'biaya layanan',
      buyMoreLabel: 'beli lebih banyak',
      buyEmptyLabel: 'beli pendek',
      buyQuantity: 'Miktar satın al',
      buyAmount: 'Jumlah Pembelian',
      submit: 'Konfirmasi pesanan'
    },
    garis: {
      buka: 'Buka:',
      tutup: 'tutup:',
      ubah: 'Atas dan bawah:'
    }
  },
  finance: {
    title: 'Keuangan'
  },
  allFinance: {
    title: 'Manajemen keuangan',
    all: 'semua'
  },
  financeOrders: {
    title: 'Perintah gadai',
    holdingLabel: 'memegang',
    historyLabel: 'Sejarah',
    holding: {
      amount: 'Jumlah janji',
      rateStr: 'jumlah pendapatan/hasil',
      vcCount: 'Jumlah koin yang dijaminkan',
      cycle: 'Siklus posisi',
      day: 'hari',
      calcStartDate: 'Mulai tanggal nilai',
      serviceAmount: 'Biaya Layanan',
      redeemOrder: 'Tukarkan'
    },
    history: {
      incomeAmount: 'jumlah pendapatan',
      rateStr: 'hasil',
      amount: 'Jumlah janji',
      vcCount: 'Jumlah koin yang dijaminkan',
      calcStartDate: 'Mulai tanggal nilai',
      calcEndDate: 'Tanggal Akhir',
      cycle: 'hari siklus',
      serviceAmount: 'Biaya Layanan',
      day: 'hari'
    }
  },
  financeOrderBills: {
    title: 'Tagihan pendapatan gadai',
    amount: 'jumlah',
    balance: 'Saldo'
  },
  financeItem: {
    rateStr: 'hasil',
    buyType: 'Tipe Beli',
    cycle: 'hari siklus',
    exchangeRate: 'Kurs (saldo pertukaran mata uang virtual)',
    day: 'hari',
    cycleType: 'tipe siklus',
    serviceRateStr: 'Tarif Layanan'
  },
  buyFinance: {
    title: 'Beli',
    rateStr: 'hasil',
    name: 'nama',
    buyType: 'Tipe Beli',
    cycle: 'hari siklus',
    cycleType: 'tipe siklus',
    exchangeRate: 'Kurs (saldo pertukaran mata uang virtual)',
    serviceRateStr: 'Tarif Layanan',
    remark: 'komentar',
    buyAmountLabel: 'Jumlah Beli ({coin})',
    descriptionTitle: 'Deskripsi Produk',
    descriptionPart1: '1. Produk ini adalah produk manajemen kekayaan tanpa jaminan pokok. Fluktuasi pasar dapat menyebabkan kerugian pokok. Silakan berinvestasi dengan hati-hati.',
    descriptionPart2: '2. Aturan penyelesaian pembayaran:',
    descriptionPart3: 'Jika harga penyelesaian < harga yang ditautkan, BTC akan diselesaikan setelah jatuh tempo; jumlah penyelesaian = jumlah investasi * (1+ hari * tingkat pengembalian tahunan / 365).',
    descriptionPart4: 'Jika harga penyelesaian ≥ harga terkait, USDT akan diselesaikan setelah jatuh tempo; jumlah penyelesaian = jumlah investasi * harga terkait * (1+ hari * tingkat pengembalian tahunan / 365).',
    descriptionPart5: '3. Tingkat pengembalian aktual tahunan berubah dengan pasar secara real time, silakan merujuk ke transaksi pembelian aktual.',
    descriptionPart6: '4. Jumlah investasi dikonversi sesuai dengan pasar secara real time, silakan lihat transaksi pembelian yang sebenarnya.',
    descriptionPart7: '5. Setelah produk dibeli, dapat dilihat di halaman penyimpanan mata uang saya, dan pengembalian dana akan secara otomatis dikeluarkan ke akun spot setelah tanggal kedaluwarsa.',
    buyButton: 'Beli [{coin}]'
  },

  fund: {
    description: 'aset',
    recharge: 'Isi ulang',
    withdraw: 'tarik koin',
    exchange: 'Transfer',
    empty: 'Dompet kosong, ayo'
  },
  userCenter: {
    lastLogin: 'Login terakhir',
    myTeam: 'Tim Saya',
    identity: 'otentikasi nama asli',
    zskAccount: 'ZSK akun',
    walletAddress: 'alamat dompet',
    bankCard: 'Rekening bank',
    userBills: 'Catatan Perubahan Akun',
    timingTradeOrder: 'Posisi sangat cepat',
    contactTradeOrder: 'Posisi kontrak',
    userReport: 'Laporan Pengguna',
    teamReport: 'laporan tim',
    share: 'Saya ingin berbagi',
    customer: 'Hubungi layanan pelanggan',
    helpCenter: 'Pusat Bantuan',
    platform: 'Pengenalan Platform',
    profit: 'Laba dan rugi hari ini',
    balance: 'Saldo saya',
    withdraw: 'Tarik koin',
    recharge: 'Isi ulang',
    creditStoreLabel: 'Point Kredit'
  },
  settings: {
    title: 'Pengaturan',
    fundPassword: 'kata sandi dana',
    googleValidator: 'Validator Google',
    editLoginPassword: 'Ubah kata sandi masuk',
    switchLocale: 'beralih bahasa'
  },
  editFundPassword: {
    title: 'Ubah Kata Sandi Dana',
    currentPasswordLabel: 'kata sandi saat ini',
    currentPasswordPlaceholder: 'Masukkan kata sandi dana saat ini',
    newPasswordLabel: 'Kata Sandi Baru',
    newPasswordPlaceholder: 'Masukkan kata sandi dana yang dimodifikasi',
    prePasswordLabel: 'Konfirmasi kata sandi',
    prePasswordPlaceholder: 'Hapus dan masukkan kembali kata sandi dana yang dimodifikasi',
    tips: 'Password dana adalah sertifikat penting untuk transaksi, harap atur dengan hati-hati dan ingat baik-baik',
    currentPasswordRequired: 'Masukkan kata sandi dana saat ini',
    newPasswordRequired: 'Masukkan sandi dana yang akan diubah',
    prePasswordRequired: 'Masukkan sandi dana untuk diubah lagi',
    prePasswordDiff: 'Dua input kata sandi tidak konsisten'
  },
  bindFundPassword: {
    title: 'Ikat kata sandi dana',
    fundPasswordLabel: 'kata sandi dana',
    fundPasswordPlaceholder: 'Masukkan kata sandi dana',
    fundPasswordPreLabel: 'Konfirmasi Kata Sandi',
    fundPasswordPrePlaceholder: 'Silakan masukkan kata sandi dana lagi',
    fundPasswordRequired: 'Masukkan kata sandi dana yang benar',
    fundPasswordPreRequired: 'Masukkan kata sandi konfirmasi yang benar',
    fundPasswordDiff: 'Kedua kata sandi tidak konsisten',
    bindSuccess: 'Kata sandi dana berhasil diikat',
    tips: 'Password dana adalah kredensial penting untuk transaksi, harap atur dengan hati-hati dan ingat baik-baik'
  },
  editLoginPassword: {
    title: 'Ubah kata sandi login',
    currentPasswordLabel: 'kata sandi saat ini',
    currentPasswordPlaceholder: 'Masukkan kata sandi login saat ini',
    newPasswordLabel: 'Kata Sandi Baru',
    newPasswordPlaceholder: 'Masukkan kata sandi login yang dimodifikasi',
    prePasswordLabel: 'Konfirmasi kata sandi',
    prePasswordPlaceholder: 'Hapus dan masukkan kembali kata sandi login yang dimodifikasi',
    tips: 'Kata sandi masuk adalah kredensial penting untuk autentikasi masuk, dll., harap atur dengan hati-hati dan ingat baik-baik',
    currentPasswordRequired: 'Masukkan kata sandi login saat ini',
    newPasswordRequired: 'Masukkan kata sandi login yang akan diubah',
    prePasswordRequired: 'Harap masukkan kembali kata sandi login yang akan diubah',
    prePasswordDiff: 'Dua input kata sandi tidak konsisten'
  },
  bindGoogleValidator: {
    title: 'Ikat Google Authenticator',
    qrCodeLabel: 'kode QR',
    keyLabel: 'Kunci',
    loginPasswordLabel: 'kata sandi masuk',
    loginPasswordPlaceholder: 'Masukkan kata sandi login Anda',
    googleCodeLabel: 'kode verifikasi Google',
    googleCodePlaceholder: 'Masukkan kode verifikasi Google 6 digit',
    tipsPart1: 'Cari Google Authenticator di app store',
    tipsPart2: 'Gunakan Google Authenticator untuk memindai kode QR di atas, atau masukkan kunci untuk pengikatan secara manual',
    tipsPart3: 'Masukkan 6 digit kode verifikasi Google di atas, klik Confirm to submit',
    loginPasswordRequired: 'Masukkan kata sandi login',
    googleCodeRequired: 'Masukkan kode verifikasi Google 6 digit'
  },
  walletAddress: {
    title: 'Alamat Dompet',
    add: '+ tambahkan alamat dompet',
    remark: 'komentar',
    addButton: 'Tambahkan alamat dompet',
    tips: 'Jika Anda ingin mengubah atau menghapus informasi alamat, harap hubungi layanan pelanggan'
  },
  addWalletAddress: {
    title: 'Tambahkan alamat dompet',
    vcChainNameIdLabel: 'tipe rantai',
    vcAccountLabel: 'alamat dompet',
    vcAccountPlaceholder: 'Masukkan alamat dompet',
    remarkLabel: 'Keterangan',
    remarkPlaceholder: 'Masukkan konten komentar',
    fundPasswordLabel: 'kata sandi dana',
    fundPasswordPlaceholder: 'Masukkan kata sandi dana Anda',
    tips: 'Alamat dompet yang ditambahkan tidak dapat diubah, harap verifikasi bahwa informasinya benar',
    vcIdRequired: 'Silakan pilih mata uang yang benar',
    vcChainNameIdRequired: 'Silakan pilih jenis rantai yang benar',
    vcAccountRequired: 'Masukkan alamat dompet yang benar',
    fundPwdRequired: 'Silakan masukkan kata sandi dana yang benar',
    addSuccess: 'Alamat dompet berhasil ditambahkan'
  },
  receiveWays: {
    title: 'Kartu Bank Saya',
    add: '+ Tambahkan kartu bank',
    tips: 'Jika Anda ingin mengubah atau menghapus informasi kartu bank, harap hubungi layanan pelanggan',
    addCardButton: 'Tambahkan kartu bank'
  },
  zskAccount: {
    title: 'Akun cepat',
    add: '+ Tambahkan akun cepat',
    tips: 'Untuk mengubah atau menghapus informasi akun, harap hubungi layanan pelanggan',
    addCardButton: 'Tambah akun'
  },
  addZskAccount: {
    title: 'Tambahkan akun cepat',
    withdrawNameLabel: 'Nama',
    withdrawNamePlaceholder: 'Silakan masukkan nama Anda',
    withdrawNameRequired: 'Nama tidak boleh kosong',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Masukkan ZSK',
    fundPasswordLabel: 'Kata sandi dana',
    fundPasswordPlaceholder: 'Masukkan kata sandi dana Anda',
    tips: 'Harap isi informasi akun yang ditambahkan dengan hati-hati, perusahaan tidak akan bertanggung jawab atas masalah penarikan yang gagal tiba karena informasi yang salah'
  },
  addBankCard: {
    title: 'Tambahkan kartu bank baru',
    withdrawNameLabel: 'Nama',
    withdrawNamePlaceholder: 'Silakan masukkan nama Anda',
    withdrawNameRequired: 'Nama tidak boleh kosong',
    zskLabel: 'ZSK',
    zskPlaceholder: 'Masukkan ZSK',
    zskRequired: 'ZSK ID Dibutuhkan',
    cardNumLabel: 'Nomor kartu bank',
    cardNumPlaceholder: 'Masukkan nomor kartu bank',
    branchLabel: 'Alamat cabang',
    branchPlaceholder: 'Masukkan alamat cabang kartu bank',
    fundPasswordLabel: 'kata sandi dana',
    fundPasswordPlaceholder: 'Masukkan kata sandi dana',
    tips: 'Kartu bank adalah data penting untuk transaksi tarik tunai, harap isi dengan hati-hati, perusahaan tidak akan bertanggung jawab atas masalah seperti kegagalan menerima uang tunai karena pengisian informasi kartu yang salah. ',
    backIdRequired: 'Silakan pilih bank rekening',
    cardNumRequired: 'Masukkan nomor kartu bank yang benar',
    fundPwdRequired: 'Masukkan kata sandi dana yang benar',
    idCardPlaceholder: 'Masukkan nomor ID Anda',
    idCardLabel: 'nomor KTP',
    idCardDiperlukan: 'Masukkan nomor ID yang benar',
    cciPlaceholder: 'Masukkan CCI kartu bank',
    branchCodePlaceholder: 'Silakan masukkan kode cabang',
    branchCodeLabel: 'Kode cabang',
    katakanaPlaceholder: 'Silakan masukkan katakana',
    katakanaLabel: 'Katakana'
  },
  userBills: {
    title: 'Catatan Perubahan Akun',
    vcName: 'Mata uang',
    amount: 'jumlah',
    balance: 'Saldo'
  },
  timingTradeOrder: {
    title: 'Perintah Trading Sangat Cepat',
    waiting: {
      title: 'Pesanan dalam proses',
      amount: 'jumlah',
      period: 'periode',
      receivePrice: 'Harga beli',
      settlement: 'penyelesaian sedang berlangsung'
    },
    history: {
      title: 'Historical Orders',
      buyInClose: 'Harga beli',
      saleOutClose: 'harga jual'
    }
  },
  userReport: {
    title: 'Laporan Pengguna',
    profit: 'Untung',
    timingTradeAmountFee: 'Biaya penanganan/pesanan perdagangan yang sangat cepat',
    timingTradePrizePoint: 'Bonus/rabat perdagangan yang sangat cepat',
    rechargeInfo: 'Biaya isi ulang/penanganan',
    withdrawInfo: 'Biaya penarikan/penanganan',
    exchangeInfo: 'Biaya penukaran/penanganan'
  },
  userReportDay: {
    title: 'Laporan Harian Pengguna',
    profit: 'Untung',
    timingTradeAmountFee: 'Biaya penanganan/pesanan perdagangan yang sangat cepat',
    timingTradePrizePoint: 'Bonus/rabat perdagangan yang sangat cepat',
    rechargeInfo: 'Biaya isi ulang/penanganan',
    withdrawInfo: 'Biaya penarikan/penanganan',
    exchangeInfo: 'Biaya penukaran/penanganan'
  },
  teamReport: {
    title: 'Laporan Tim',
    goToReportDay: 'Lihat laporan harian',
    timingTradeBetAmountServiceCharge: 'Pesanan perdagangan/biaya layanan yang sangat cepat',
    timingTradeBetPrizePoint: 'Bonus/Rabat Trading Cepat',
    timingTradeUserAndCount: 'Jumlah pedagang cepat/jumlah transaksi',
    rechargeAmountFee: 'Jumlah isi ulang/biaya layanan',
    rechargePersonCount: 'Isi ulang orang/jumlah transaksi',
    withdrawAmountFee: 'jumlah penarikan/biaya layanan',
    withdrawPersonCount: 'Jumlah orang yang menarik uang/transaksi',
    firstRechargeUserAndCount: 'Jumlah isi ulang pertama/jumlah orang',
    usernamePlaceholder: 'Masukkan nama pengguna tingkat rendah',
    previewAllTradeInfo: 'Lihat semua informasi perdagangan cepat',
    coin: 'mata uang',
    timingTradeBetAmount: 'Jumlah taruhan perdagangan yang sangat cepat',
    profit: 'Untung',
    action: 'operasi',
    previewReportDay: 'Lihat laporan harian'
  },
  teamTimingTradeInfo: {
    title: 'Perdagangan Kecepatan Tim',
    profit: 'Untung',
    subTitle: 'Informasi transaksi kecepatan tim',
    timingTradeAmountFee: 'Biaya pesanan/layanan perdagangan yang sangat cepat',
    timingTradePrizePoint: 'Bonus/rabat perdagangan yang sangat cepat',
    rechargeInfo: 'Isi Ulang/Biaya Layanan',
    withdrawInfo: 'Penarikan/Biaya Layanan',
    exchangeInfo: 'Biaya Pertukaran/Layanan'
  },
  teamReportDay: {
    title: 'Laporan Harian Tim',
    subTitle: 'Laporan Harian Tim [{username}]',
    timingTradeBetAmountFee: 'Biaya pesanan/layanan perdagangan yang sangat cepat',
    timingTradeBetPrizePoint: 'Bonus/Rabat Trading Cepat',
    rechargeAmountFee: 'Jumlah isi ulang/biaya layanan',
    rechargePersonCount: 'Isi ulang orang/jumlah transaksi',
    timingTradeUserAndCount: 'Jumlah pedagang cepat/jumlah transaksi',
    firstRechargePersonCount: 'Jumlah isi ulang pertama/jumlah transaksi',
    withdrawAmountFee: 'jumlah penarikan/biaya layanan',
    withdrawPersonCount: 'Jumlah orang yang menarik uang/transaksi',
    exchangeAmountFee: 'Jumlah Pertukaran/Biaya Layanan'
  },
  share: {
    title: 'Saya ingin berbagi',
    qrCodeLabel: 'kode QR',
    registerUrlLabel: 'Alamat pendaftaran',
    inviteCodeLabel: 'Kode Undangan',
    hasNoInviteCode: 'Akun saat ini tidak memiliki kode undangan,',
    generateInvitationCode: 'Coba buat dengan satu klik',
    tipsPart1: 'Pindai kode QR di atas untuk mengisi informasi pendaftaran untuk mendaftar',
    tipsPart2: 'Salin alamat pendaftaran dan isi informasi pendaftaran untuk mendaftar',
    tipsPart3: 'Buka antarmuka pendaftaran situs ini secara manual dan isi kode undangan untuk mendaftar',
    saveImageError: 'Gagal menyimpan gambar, coba tekan lama gambar dan simpan'
  },
  myTeam: {
    title: 'Tim Saya',
    usernamePlaceholder: 'Masukkan nama pengguna tingkat rendah',
    point: 'potongan harga (kecepatan/kontrak)',
    totalBalance: 'Saldo',
    lastLoginTime: 'Waktu Masuk Terakhir',
    noLoginTime: 'tidak ada'
  },
  userDetail: {
    username: 'nama pengguna',
    userType: 'Jenis Pengguna',
    title: 'Detail Pengguna',
    pointPercentTiming: 'Rabat transaksi yang sangat cepat',
    pointPercentContract: 'Rabat transaksi kontrak',
    registerWay: 'Metode pendaftaran',
    teamCounts: 'Nomor tim',
    teamOnline: 'tim daring',
    balance: 'Saldo',
    registerTime: 'Waktu pendaftaran',
    onlineStatus: 'status masuk'
  },
  addUser: {
    title: 'Tambah Pengguna',
    addUserDirect: {
      userTypeLabel: 'Jenis Pengguna',
      usernameLabel: 'Nama Pengguna',
      usernamePlaceholder: 'Masukkan nama pengguna akun',
      pointTimingLabel: 'Rabat transaksi yang sangat cepat',
      pointContractLabel: 'Rabat transaksi kontrak',
      tips: 'Kata sandi awal adalah: "{kata sandi}"; tolong ingatkan pengguna untuk mengubah kata sandi tepat waktu setelah membuka akun',
      userTypeRequired: 'Silakan pilih jenis akun',
      usernameRequired: 'Masukkan nama pengguna akun',
      pointTimingRequired: 'Silakan pilih rebate transaksi yang cepat',
      pointContractRequired: 'Silakan pilih rabat transaksi kontrak',
      copyTemplate: `
         Nama pengguna: {nama pengguna};
         Kata sandi masuk: {loginPassword};
         URL Masuk: {loginAddress};
         Rabat perdagangan cepat: {timingTradePoint};
         Rabat perdagangan kontrak: {contactTradePoint};
         `
    }
  },
  recharge: {
    title: 'Isi ulang',
    configIdLabel: 'Saluran deposit',
    chainNameLabel: 'nama rantai',
    amountLabel: 'Jumlah isi ulang',
    userCardNameLabel: 'Pembayar',
    userCardNamePlaceholder: 'Masukkan nama pembayar',
    fee: 'biaya layanan',
    acceptAmountTipsPart1: 'Isi ulang',
    acceptAmountTipsPart2: ', perlu membayar',
    tipsPart1: 'Karena antarmuka pembayaran online tidak stabil, saat ini hanya isi ulang transfer offline yang didukung! ',
    tipsPart2: 'Harap isi jumlah transfer yang sebenarnya dengan jujur, jika tidak maka dapat menyebabkan peninjauan sistem gagal dan memengaruhi kemajuan pengisian ulang. ',
    emptyPart1: 'Tidak ada saluran isi ulang yang tersedia, ',
    emptyPart2: 'Ketuk untuk mencoba lagi',
    amountRequired: 'Jumlah isi ulang tidak boleh kosong',
    maxPrecisionError: 'Jumlah isi ulang dapat memiliki hingga {amountMaxPrecision} tempat desimal',
    payUserNameError: 'Masukkan pembayar yang benar dan coba lagi',
    userMobileLabel: 'Nomor ponsel',
    userMobilePlaceholder: 'Masukkan nomor ponsel pengguna',
    needPayLabel: 'Perlu membayar',
    needPayPlaceholder: 'Klik untuk memasukkan [{simbol}] jumlah'
  },
  payDetail: {
    title: 'Transfer informasi',
    addressLabel: 'Alamat setoran',
    rechargeAmount: 'Jumlah Isi Ulang',
    bankNameLabel: 'Bank',
    branchLabel: 'Alamat cabang',
    cardName: 'Nama',
    cardNum: 'nomor kartu',
    uploadImgLabel: 'Kredensial Pembayaran',
    uploadImgPlaceholder: 'Klik untuk mengunggah gambar voucher pembayaran',
    uploadImgRequired: 'Silakan unggah gambar voucher pembayaran',
    vcTransferTipsPart1: '1. Salin alamat setoran atau pindai kode QR untuk menyetor',
    vcTransferTipsPart2: '2. Unggah gambar voucher pembayaran setelah deposit selesai',
    vcTransferTipsPart3: 'Untuk meningkatkan efisiensi setoran, pastikan untuk mengunggah gambar sertifikat yang jelas dan berdefinisi tinggi, jika gambar informasi yang relevan tidak jelas, ini dapat menyebabkan sistem gagal meninjau dan memengaruhi kemajuan setoran. ',
    bankCardTips: 'Untuk meningkatkan efisiensi penyetoran uang, harap pastikan bahwa nama pengirim dan pengirim sama; jika informasi yang relevan tidak cocok, dapat menyebabkan sistem gagal meninjau dan mempengaruhi kemajuan dari deposito. ',
    bankCardTransferSuccess: 'Saya telah berhasil mentransfer'
  },
  rechargeOrder: {
    title: 'Pesanan Deposit',
    payAmount: 'Jumlah isi ulang',
    receiveAmount: 'jumlah yang diterima'
  },
  identity: {
    title: 'Informasi nama asli',
    subTitle: 'Otentikasi nama asli mencakup otentikasi informasi, otentikasi identitas',
    name: 'Nama',
    idType: 'tipe dokumen',
    idNum: 'nomor ID',
    demand: 'membutuhkan',
    informationVer: 'Verifikasi Informasi',
    idAuthentication: 'Otentikasi',
    material: 'Bahan'
  },
  verified: {
    title: 'Otentikasi nama asli',
    idCardTypeLabel: 'Jenis Sertifikat',
    idCardFrontSideImgLabel: 'Kartu Depan SideImgLabel',
    idCardBackSideImgLabel: 'Bagian belakang foto ID',
    idCardHandSideImgLabel: 'foto ID genggam',
    nameLabel: 'Nama dokumen',
    namePlaceholder: 'Masukkan nama ID Anda',
    idCardNumLabel: 'nomor KTP',
    idCardNumPlaceholder: 'Masukkan nomor ID',
    fundPwdLabel: 'kata sandi dana',
    fundPwdPlaceholder: 'Masukkan kata sandi dana Anda',
    tips: 'Otentikasi informasi setelah dikirimkan, tidak dapat diubah, harap periksa dengan cermat dan isi dengan benar',
    idCardTypeRequired: 'Silakan pilih jenis kartu',
    idCardFrontSideImgRequired: 'Unggah foto depan KTP',
    idCardBackSideImgRequired: 'Mohon unggah foto bagian belakang KTP',
    idCardHandSideImgRequired: 'Harap unggah foto ID genggam',
    nameRequired: 'Masukkan nama dokumen',
    idCardNumRequired: 'Masukkan nomor ID',
    fundPwdRequired: 'Masukkan kata sandi dana Anda',
    submitSuccess: 'Permintaan otentikasi berhasil dikirim'
  },
  help: {
    title: 'Pusat Bantuan'
  },
  helpDetail: {
    title: 'Detail Bantuan'
  },
  myMessage: {
    title: 'Pesan Saya'
  },
  messageDetail: {
    title: 'Detail pesan'
  },
  withdraw: {
    title: 'Tarik koin',
    tips: 'Untuk memastikan keamanan dana dan efisiensi penarikan; harap hati-hati memeriksa apakah informasi yang diisi sudah benar, dan biaya penanganan yang dihasilkan selama proses penarikan akan dipotong dari saldo',
    receiveAmountTipsPart1: 'Tarik',
    receiveAmountTipsPart2: ', diharapkan tiba',
    fee: 'biaya layanan',
    myBalance: 'Saldo [{vcName}] saya:',
    configIdLabel: 'saluran penarikan',
    amountLabel: 'jumlah penarikan',
    fundLabel: 'kata sandi dana',
    fundPlaceholder: 'Masukkan kata sandi dana Anda',
    googleCodeLabel: 'kode verifikasi Google',
    googleCodePlaceholder: 'Masukkan kode verifikasi Google 6 digit',
    maxPrecisionError: 'Jumlah penarikan dapat memiliki hingga {amountMaxPrecision} tempat desimal',
    amountRequired: 'Masukkan atau pilih jumlah penarikan yang benar',
    bankCardError: 'Silakan pilih kartu bank yang benar',
    fundPwdError: 'Masukkan kata sandi dana yang benar',
    walletAddressError: 'Silakan pilih alamat dompet yang benar',
    success: 'Permintaan penarikan berhasil dikirim, harap tunggu pemrosesan',
    emptyPart1: 'Tidak ada saluran penarikan yang tersedia,',
    emptyPart2: 'Ketuk untuk mencoba lagi'
  },
  withdrawOrder: {
    title: 'Pesanan penarikan',
    requestAmount: 'Jumlah bill of lading',
    receiveAmount: 'jumlah yang diterima'
  },
  locales: {
    title: 'Ganti bahasa'
  },
  lines: {
    title: 'Pemilihan Jalur',
    switchLine: 'switch line'
  },
  currencyPop: {
    deleteFavoriteSuccess: 'Berhasil menghapus mata uang favorit',
    addFavoriteSuccess: 'Berhasil menambahkan mata uang favorit'
  },
  currencySelect: {
    currencyName: 'mata uang',
    currencyPlaceholder: 'Klik untuk memilih mata uang'
  },
  walletItem: {
    available: 'tersedia',
    convert: 'konversi (USDT)'
  },
  banks: {
    bankIdLabel: 'Bank',
    bankIdPlaceholder: 'Klik untuk memilih bank'
  },
  banksPop: {
    title: 'Pilih Bank',
    search: 'Masukkan kata kunci bank'
  },
  historyOrderDetail: {
    title: 'Rincian Pesanan',
    coin: 'Mata uang transaksi',
    amount: 'jumlah pesanan',
    buyInClose: 'Harga beli',
    sellOutClose: 'Harga Jual',
    isQuest: 'Ada pertanyaan tentang pesanan ini?',
    connectCustomer: 'Hubungi layanan pelanggan?'
  },
  pointSelect: {
    prizeGroupPlaceholder: 'Klik untuk memilih rabat pengguna'
  },
  walletAddressSelect: {
    title: 'Pilih alamat dompet',
    label: 'alamat dompet',
    placeholder: 'Klik untuk memilih alamat dompet'
  },
  myCardSelect: {
    title: 'Pilih akun',
    label: 'rekening penerima',
    placeholder: 'Klik untuk memilih akun'
  },
  amountInput: {
    amountRange: 'minimum {minAmount}, maksimum {maxAmount}',
    amountMin: 'Minimum {minAmount}, tanpa batas atas',
    amountErrorEmpty: '{label} salah, harap periksa dan coba lagi',
    amountErrorOutRange: '{label} di luar jangkauan, harap periksa dan coba lagi'
  },
  amountFormItem: {
    placeholderOnlyMin: 'Minimum {minAmount}, tanpa batas atas',
    placeholderHasMax: 'minimum {minAmount}, maksimum {maxAmount}',
    amountErrorEmpty: 'Jumlahnya salah, silakan coba lagi setelah verifikasi',
    amountErrorOutRange: 'Jumlahnya di luar jangkauan, harap verifikasi dan coba lagi'
  },
  common: {
    remark: 'komentar',
    saveImage: 'Simpan secara lokal',
    online: 'daring',
    offline: 'offline',
    profit: 'untung dan rugi',
    date: 'tanggal',
    period: 'periode',
    pointAmount: 'Jumlah rabat pengguna',
    point: 'Rabat pengguna',
    direction: 'arah',
    winLoss: 'Penghasilan',
    lose: 'kalah',
    add: 'Tambah baru',
    win: 'menang',
    edit: 'Ubah',
    notBind: 'tidak terikat',
    alreadyBind: 'sudah terikat',
    enabled: 'diaktifkan',
    notEnabled: 'tidak diaktifkan',
    queryRange: 'Rentang Kueri',
    copy: 'Salin',
    orderNum: 'nomor pesanan',
    null: 'tidak ada',
    noData: 'Tidak ada data',
    refreshSuccess: 'Berhasil menyegarkan',
    loadMoreData: 'Muat lebih banyak data',
    noMoreData: 'Tidak ada lagi data',
    lookMore: 'Lagi',
    more: 'Lagi'
  },
  date: {
    today: 'hari ini',
    yesterday: 'Kemarin',
    last7Days: 'hampir 7 hari',
    last14Days: 'hampir 14 hari',
    split: 'ke'
  },
  button: {
    save: 'Simpan',
    logout: 'keluar',
    confirm: 'OK',
    cancel: 'Batal',
    submit: 'Kirim',
    addNow: 'Tambahkan sekarang',
    reset: 'setel ulang',
    nextStep: 'Berikutnya',
    goCertification: 'Pergi ke sertifikasi'
  },
  confirm: {
    title: {
      logout: 'keluar',
      unBindFundPassword: 'kata sandi dana tidak terikat',
      addUserDirect: 'Tambah Pengguna',
      addUserInfo: 'Berhasil menambahkan pengguna',
      jumpToRechargePage: 'Konfirmasi Lompat',
      unAuthentication: 'autentikasi nama tidak nyata',
      noBindBankCard: 'Tidak ada kartu bank yang ditambahkan',
      noBindCoinAddress: 'Tidak ada alamat dompet yang ditambahkan',
      tradeConfirm: 'Konfirmasi transaksi',
      buyFinance: 'Konfirmasi pembelian',
      redeemOrder: 'Penukaran pesanan janji'
    },
    content: {
      logout: 'Apakah Anda yakin untuk keluar dari akun saat ini?',
      unBindFundPassword: 'Kata sandi dana yang tidak terikat telah terdeteksi, untuk memastikan keamanan akun, harap ikat kata sandi dana Anda terlebih dahulu',
      addUserDirect: 'Pengguna baru akan segera ditambahkan, harap verifikasi bahwa informasinya benar dan klik OK untuk melanjutkan, nama pengguna [ {username} ], tipe pengguna [ {userType} ], kata sandi login [ {password} ], dan selisih antara rabat perdagangan cepat saya [ {diffPointTiming} ], dan selisih rabat transaksi kontrak saya [ {diffPointContract} ]',
      addUserInfo: 'Username [ {username} ]; <br /> Login password [ {password} ];<br /> Login URL [ {loginAddress} ];<br /> Ekstrim rabat transaksi [ {pointPercentTiming} ];<br / > /> Rabat transaksi kontrak [{pointPercentContract}];',
      jumpToRechargePage: 'Tentang melompat ke antarmuka isi ulang tiga pihak, silakan klik konfirmasi untuk melanjutkan',
      unAuthentication: 'Terdeteksi bahwa akun belum menjalani autentikasi nama asli, untuk memastikan peredaran dana normal, harap lakukan autentikasi nama asli terlebih dahulu',
      noBindBankCard: 'Terdeteksi bahwa akun tidak terikat atau diaktifkan dengan kartu bank. Untuk memastikan sirkulasi dana normal, harap tambahkan kartu bank terlebih dahulu',
      noBindCoinAddress: 'Terdeteksi bahwa akun tidak terikat atau mengaktifkan akun mata uang virtual. Untuk memastikan sirkulasi dana normal, harap tambahkan alamat akun mata uang virtual terlebih dahulu',
      tradeConfirm: 'Pesanan akan segera dikirim, harap pastikan informasi pesanan sudah benar dan klik Konfirmasi Pesanan untuk mengirimkan',
      buyFinance: 'Akan membeli [{coin}], beli saham: {amount}, harap konfirmasikan bahwa pengoperasian sudah benar dan klik OK untuk melanjutkan',
      redeemOrder: 'Pesanan kontribusi ({orderNum}) akan ditukarkan, harap konfirmasikan bahwa pengoperasian sudah benar dan klik Konfirmasi untuk melanjutkan'
    }
  },
  message: {
    bindSuccess: 'Bind berhasil',
    successOperation: 'Operasi berhasil',
    logoutSuccess: 'Berhasil keluar',
    editSuccess: 'Berhasil dimodifikasi',
    addSuccess: 'Berhasil dimodifikasi',
    copySuccess: 'Penyalinan berhasil',
    copyFailed: 'Penyalinan gagal'
  },
  vux: {
    'inline-calendar': {
      week_day_0: 'Hari',
      week_day_1: 'Satu',
      week_day_2: 'dua',
      week_day_3: 'tiga',
      week_day_4: 'empat',
      week_day_5: 'lima',
      week_day_6: 'Enam'
    },
    loading: {
      loading: 'memuat'
    }
  },
  helpItems: {
    title: {
      part1: 'Mengapa jumlah aset yang dikonversi berubah? ',
      part2: 'Lupa metode penanganan kata sandi dana untuk transaksi OTC',
      part3: 'Kemana aliran dana setelah pembelian transaksi OTC selesai? ',
      part4: 'Mengapa Anda ingin membatasi berapa kali Anda dapat mengubah nama panggilan Anda',
      part5: 'Apa arti transfer, mengapa perlu transfer',
      part6: 'Bagaimana cara menghitung ekuitas akun dari kontrak pengguna? ',
      part7: 'Berapa nilai stop loss dan take profit yang ditetapkan pada posisi pembukaan? Bagaimana cara mengaturnya? ',
      part8: 'Bagaimana cara mengurangi risiko kontrak? ',
      part9: 'Apa yang ditunjukkan oleh kuantitas dalam posisi terbuka kontrak? ',
      part10: 'Petunjuk likuidasi paksa',
      part11: 'Apa aturan perdagangan kontrak? ',
      part12: 'Berapa margin dalam perdagangan kontrak? ',
      part13: 'Apa itu limit order dan market order? ',
      part14: 'Apa yang diwakili oleh risiko transaksi kontrak',
      part15: 'Mengapa Anda memerlukan konversi mata uang? ',
      part16: 'Mengapa pihak lain tidak menerima transfer tepat waktu setelah transfer transaksi OTC? ',
      part17: 'Bagaimana cara membeli Tether (USDT) melalui OTC? '
    },
    content: {
      part1: 'Nilai mata uang digital yang saat ini dipegang dalam Renminbi saat diubah menjadi aset akan berubah karena fluktuasi harga aset digital. Jumlah aset digital Anda tidak berubah. ',
      part2: 'Jika Anda lupa kata sandi dana transaksi OTC, silakan buka "Pengaturan-Saya-Klik untuk mengatur kata sandi dana" atau hubungi layanan pelanggan untuk mengatur ulang',
      part3: 'Setelah pesanan beli OTC selesai, dana akan masuk ke akun mata uang resmi di aset. Jika Anda perlu menggunakan aset yang dibeli OTC untuk perdagangan kontrak atau perdagangan berjangka, silakan buka modul transfer dana untuk mentransfer. ',
      part4: 'Untuk alasan keamanan transaksi Anda, saat ini kami membatasi nama panggilan untuk diubah hanya sekali. ',
      part5: 'Untuk memastikan independensi dana antara berbagai akun Anda dan untuk memfasilitasi kontrol risiko Anda yang wajar, akun modul perdagangan utama dengan ini dibagi. Transfer mengacu pada proses saling konversi aset antara berbagai akun perdagangan. ',
      part6: '<p>Ekuitas akun kontrak, metode perhitungannya adalah sebagai berikut:</p> <p>Ekuitas akun kontrak = margin posisi + keuntungan dan kerugian mengambang posisi + jumlah tersedia akun saat ini</p>',
      part7: 'Take profit and stop loss adalah batas keuntungan dan batas kerugian yang Anda tetapkan. Ketika jumlah stop profit dan stop loss yang ditetapkan tercapai, sistem akan menutup posisi secara otomatis. Hal ini dapat digunakan untuk pengendalian risiko Anda saat membeli kontrak. Setengah dari jumlah take profit yang ditetapkan adalah: tingkatkan jumlah x jumlah x leverage berlipat, dan tetapkan stop loss. Kami sarankan Anda mengaturnya sesuai dengan situasi aset Anda yang sebenarnya untuk mengendalikan risiko secara wajar . ',
      part8: 'Anda dapat mentransfer aset yang tersedia dari akun yang tersisa ke akun kontrak dengan mentransfer dana, atau mengurangi risiko dengan mengurangi posisi. ',
      part9: 'Kuantitas dalam posisi terbuka menunjukkan jumlah mata uang yang ingin Anda beli. Misalnya: pada halaman pembuka pasangan perdagangan BTC/USDT, pilih untuk membeli long, masukkan harga sebagai 1000USDT, dan masukkan kuantitas sebagai 10BTC, yang artinya: Anda berharap untuk membeli 10 BTC dengan harga satuan 1000USDT. ',
      part10: '<p>Tingkat risiko adalah indikator untuk mengukur risiko aset Anda. Ketika tingkat risiko sama dengan 100%, posisi Anda dianggap likuidasi. Tingkat risiko=(margin posisi/ekuitas akun kontrak)*100 %, untuk mencegah pengguna melebihi posisi mereka, sistem menetapkan rasio penyesuaian tingkat risiko.Ketika tingkat risiko mencapai nilai risiko yang ditetapkan oleh sistem, sistem akan memaksa likuidasi. Misalnya: jika rasio penyesuaian yang ditetapkan oleh sistem adalah 10%, maka ketika tingkat risiko Anda lebih besar atau sama dengan 90%, semua posisi Anda akan ditutup paksa oleh sistem. </p> <p>Catatan: Jika sistem memaksa likuidasi yang disebabkan oleh risiko berlebihan, semua posisi Anda akan ditutup, jadi saya harap Anda dapat mengontrol risiko Anda secara wajar untuk menghindari kerugian yang tidak perlu< /p>',
      part11: '<p>Jenis perdagangan</p> <p>Jenis perdagangan dibagi menjadi dua arah: buka posisi long (beli) dan buka posisi short (jual):</p> <p>Beli long (Calling) artinya bahwa Anda percaya bahwa indeks saat ini akan naik, dan berharap untuk membeli sejumlah kontrak tertentu dengan harga yang Anda tetapkan atau harga pasar saat ini. </p> <p>Short selling (bearish) berarti Anda percaya bahwa indeks saat ini mungkin turun, dan berharap untuk menjual sejumlah kontrak tertentu dengan harga yang Anda tetapkan atau harga pasar saat ini. </p> <p>Cara melakukan pemesanan</p> <p>Pemesanan batas: Anda perlu menentukan harga dan jumlah pesanan</p> <p>Pesanan pasar: Anda hanya perlu mengatur jumlah order , harga adalah harga pasar saat ini</p> <p>Posisi</p> <p>Ketika order pembukaan yang Anda kirimkan selesai, itu disebut posisi</p> <p>Masalah pengiriman kontrak </p> <p>Kontrak platform adalah kontrak abadi tanpa waktu pengiriman yang ditentukan. Selama kondisi likuidasi sistem tidak terpenuhi atau Anda tidak menutup posisi secara manual, Anda dapat menahan posisi tersebut secara permanen. </p> <p>Sistem menutup posisi</p> <p>1: Sistem secara otomatis menutup posisi ketika nilai stop profit dan stop loss yang ditetapkan tercapai</p> <p>2: Risiko terlalu tinggi, sistem memaksa posisi ditutup </p>',
      part12: '<p>Dalam transaksi kontrak, pengguna dapat berpartisipasi dalam transaksi kontrak dengan membayar dana sebagai jaminan keuangan untuk pelaksanaan kontrak sesuai dengan harga dan kuantitas kontrak, sesuai dengan kelipatan leverage yang sesuai, dan dana ini adalah margin kontrak. Pengguna akan menempati margin saat membuka posisi, dan semakin banyak margin untuk membuka posisi yang ditempati, semakin tinggi risiko akun. </p> <p>Margin = (harga pembukaan * kuantitas) / rasio leverage</p>',
      part13: 'Batas pesanan mengacu pada harga yang Anda harapkan untuk mempercayakan platform untuk melakukan transaksi, dan pesanan pasar mengacu pada mempercayakan platform secara langsung untuk melakukan transaksi dengan harga saat ini. Dalam aturan pembukaan posisi, market order diprioritaskan di atas limit order. Jika Anda memilih limit order, harap buka posisi secara wajar sesuai dengan harga pasar mata uang saat ini untuk menghindari kerugian yang disebabkan oleh harga pembukaan yang tidak wajar. ',
      part14: 'Tingkat risiko adalah indikator risiko di akun kontrak Anda, dan tingkat risiko sama dengan 100% dianggap likuidasi. Kami menyarankan Anda, ketika risiko Anda melebihi 50%, Anda perlu membuka posisi dengan hati-hati untuk menghindari kerugian akibat likuidasi. Anda dapat mengurangi risiko Anda dengan mengisi kembali dana aset kontrak yang tersedia, atau mengurangi posisi. ',
      part15: 'Fungsi bursa adalah untuk memungkinkan kelancaran sirkulasi dana dalam berbagai mata uang di aset Anda, dan QCC yang diperoleh di akun berjangka dapat secara bebas dikonversi menjadi USDT untuk diperdagangkan. USDT di akun lain juga dapat dengan bebas dikonversi menjadi QCC untuk transaksi. ',
      part16: 'Pertama-tama, harap pastikan metode pembayaran yang Anda isi saat mentransfer uang sama persis dengan yang ditampilkan di halaman detail pesanan. Kemudian harap konfirmasi apakah metode pembayaran Anda instan atau tertunda. Terakhir, harap hubungi bank dan lembaga pembayaran Anda untuk pemeliharaan sistem atau alasan lainnya. ',
      part17: '<p>Metode 1: Pilih pesanan yang ingin Anda beli melalui daftar jual beli OTC untuk membeli atau menjual. </p> <p>Metode 2: Klik tombol terbitkan untuk menerbitkan pesanan beli atau jual sesuai kebutuhan Anda untuk transaksi cepat. Sistem akan dengan cepat mencocokkan Anda dengan pembeli dan penjual. </p> <p>Catatan: Jika pesanan pembelian tidak dibayar setelah 15 menit, sistem akan membatalkan pesanan secara otomatis, harap bayar tepat waktu. Jika pesanan dibatalkan lebih dari 3 kali pada hari yang sama, transaksi tidak dapat dilakukan lagi pada hari yang sama, dan otoritas perdagangan akan dipulihkan pada hari berikutnya. </p>'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/id.js